import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState } from './types';

// The initial state of the header container
export const initialState: ContainerState = {
  dealers: { data: {}, loading: false, error: null },
  selectedDealer: 'default',
  isDealerSelectEnabled: true,
  isDrawerOpen: false
};

const headerSlice = createSlice({
  name: 'headerState',
  initialState,
  reducers: {
    requestDealers(state) {
      state.dealers.data = {};
      state.dealers.loading = true;
      state.dealers.error = null;
    },
    requestDealersSuccess(state, action: PayloadAction<any>) {
      state.dealers.data = action.payload;
      state.dealers.loading = false;
    },
    requestDealersError(state, action: PayloadAction<any>) {
      state.dealers.error = action.payload;
      state.dealers.loading = false;
    },
    selectDealer(state, action: PayloadAction<any>) {
      state.selectedDealer = action.payload;
    },
    toggleDealerSelect(state, action: PayloadAction<any>) {
      state.isDealerSelectEnabled = action.payload;
    },
    setDealer(state, action: PayloadAction<any>) {
      state.selectedDealer = 'default';
    },
    setDrawerOpen(state, action: PayloadAction<any>) {
      state.isDrawerOpen = action.payload || false
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.dealers.loading = action.payload;
    }
  },
});

export const { actions: headerActions, reducer, name: sliceKey } = headerSlice;

